import React, { Component } from "react";
import photo from "./Components/assets/hubspot.png";
import { Button } from "@material-ui/core";

class ThanksHubspot extends Component {
  state = {};
  componentWillMount() {
    // setTimeout(() => {
    //   window.close();
    // }, 3000);
  }
  render() {
    return (
      <div>
        <center>
          <img
            src={photo}
            style={{ width: "140px", height: "105px", marginTop: "30px" }}
          />
          <h1>Thanks for connecting with Hubspot</h1>
          <h2>Click on logout to exit</h2>
          <Button
            style={{
              background: "#0456d9",
              fontFamily: "inherit",
              fontSize: "12px",
              color: "white",
            }}
            onClick={() =>
              (window.location =
                "https://app.hubspot.com/login-api/v1/logout/all")
            }
          >
            {" "}
            LogOut
          </Button>
        </center>
      </div>
    );
  }
}

export default ThanksHubspot;
